import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { STATUS_FLOW } from "../lib/constants";
import { Download } from "lucide-react";

export default function ReportsPage() {
  const [status, setStatus] = useState("all");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const download = (kind) => {
    const params = new URLSearchParams();
    if (status !== "all") params.append("status", status);
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/reports/returns.csv?${params.toString()}`;
    window.open(url, "_blank");
  };

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="heading text-3xl font-bold text-slate-900">Reports</h1>
        <p className="text-slate-500 mt-1">Generate and export RMA reports.</p>
      </div>

      <Card>
        <CardHeader><CardTitle className="heading text-base">Filters</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <Label>Status</Label>
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger data-testid="reports-status"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All</SelectItem>
                {STATUS_FLOW.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div><Label>From</Label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
          <div><Label>To</Label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { name: "Customer Return Report", desc: "All return requests with full details" },
          { name: "Pending Returns", desc: "Open requests across all stages" },
          { name: "Credit Note Report", desc: "All credit notes issued" },
        ].map((r) => (
          <Card key={r.name} className="hover:shadow-md transition-shadow">
            <CardContent className="p-5">
              <div className="heading font-semibold text-slate-900">{r.name}</div>
              <p className="text-sm text-slate-500 mt-1 mb-4">{r.desc}</p>
              <Button variant="outline" onClick={() => download(r.name)} data-testid={`download-${r.name.toLowerCase().replace(/\s+/g, "-")}`}>
                <Download className="w-4 h-4 mr-2" /> Export CSV
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
